import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import './App.css';
import './index.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Templates from './pages/Templates';
import EmailBuilderUnlayer from './pages/EmailBuilderUnlayer';
import SendGridSettings from './pages/SendGridSettings';
import Domains from './pages/Domains';
import UnsubscribeLogs from './pages/UnsubscribeLogs';
import Settings from './pages/Settings';
import Unsubscribe from './pages/Unsubscribe';
import UnsubscribeConfirm from './pages/UnsubscribeConfirm';
import Subscribers from './pages/Subscribers';
import Campaigns from './pages/Campaigns';
import CampaignCreate from './pages/CampaignCreate';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0C10] flex items-center justify-center">
        <div className="text-[#F3F4F6]">Loading...</div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/unsubscribe/confirm" element={<UnsubscribeConfirm />} />
          
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
          <Route path="/builder/:id?" element={<ProtectedRoute><EmailBuilderUnlayer /></ProtectedRoute>} />
          <Route path="/subscribers" element={<ProtectedRoute><Subscribers /></ProtectedRoute>} />
          <Route path="/campaigns" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
          <Route path="/campaigns/create" element={<ProtectedRoute><CampaignCreate /></ProtectedRoute>} />
          <Route path="/sendgrid" element={<ProtectedRoute><SendGridSettings /></ProtectedRoute>} />
          <Route path="/domains" element={<ProtectedRoute><Domains /></ProtectedRoute>} />
          <Route path="/unsubscribe-logs" element={<ProtectedRoute><UnsubscribeLogs /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
